import React from 'react';
import { useTranslation } from 'react-i18next';
// SVG Icons for Socials
const TikTokIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" aria-label="TikTok">

    <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"/>
  </svg>
);
const InstagramIcon = () => (
  <svg
    /* The width and height are now controlled by CSS for responsiveness */
    viewBox="0 0 551.034 551.034"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-label="Instagram"
  >
    <path
      d="M387.4,0H163.6C73.3,0,0,73.3,0,163.6v223.8c0,90.3,73.3,163.6,163.6,163.6h223.8
         c90.3,0,163.6-73.3,163.6-163.6V163.6C551,73.3,477.7,0,387.4,0z M495,387.4c0,59.3-48.3,107.6-107.6,107.6H163.6
         C104.3,495,56,446.7,56,387.4V163.6C56,104.3,104.3,56,163.6,56h223.8C446.7,56,495,104.3,495,163.6V387.4z"
    />
    <path
      d="M275.5,133.1c-78.5,0-142.4,63.9-142.4,142.4s63.9,142.4,142.4,142.4
         s142.4-63.9,142.4-142.4S354,133.1,275.5,133.1z M275.5,362.7c-48.2,0-87.3-39.1-87.3-87.3s39.1-87.3,87.3-87.3
         s87.3,39.1,87.3,87.3S323.7,362.7,275.5,362.7z"
    />
    <circle cx="418.3" cy="134.8" r="34.9" />
  </svg>
);
const WhatsAppIcon = () => (
  <svg xmlns="https://chat.whatsapp.com/DhjdBxSDOP4BwuSrc5vGq6?mode=ac_t" fill="currentColor" viewBox="0 0 16 16" aria-label="WhatsApp">
    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
  </svg>
);
const SocialBar = () => {
  const { t } = useTranslation();

  return (
    <section className="social-bar-section">
      <div className="footer-social-bar">
        <h2>{t('socialBar.letsBeFriends')}</h2>
        <div className="social-bar-icons">
          <a href="https://www.tiktok.com/@zizi_pickleball" target="_blank" rel="noopener noreferrer" aria-label={t('socialBar.tiktokAriaLabel')}>
            <TikTokIcon />
          </a>
          <a href="https://www.instagram.com/zizi_pickleball/" target="_blank" rel="noopener noreferrer" aria-label={t('socialBar.instagramAriaLabel')}>
            <InstagramIcon />
          </a>
          <a href="https://wa.me/385913782937" target="_blank" rel="noopener noreferrer" aria-label={t('socialBar.whatsappAriaLabel')}>
            <WhatsAppIcon />
          </a>
        </div>
      </div>
    </section>
  );
};

export default SocialBar;